// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MTbr","left":"styles_left__2neVP","right":"styles_right__2ZqNR","alert":"styles_alert__3CZq7"};